import { render, staticRenderFns } from "./OnboardingDocumentCollection.vue?vue&type=template&id=539eda94&scoped=true&"
import script from "./OnboardingDocumentCollection.vue?vue&type=script&lang=ts&"
export * from "./OnboardingDocumentCollection.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingDocumentCollection.vue?vue&type=style&index=0&id=539eda94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539eda94",
  null
  
)

export default component.exports